import React from 'react'
import styles from './co-host-notice.scss'
import SendInviteBg from 'src/assets/send-invite-bg.jpg'
import CheckoutFrame from '../components/CheckoutFrame'
import PropTypes from 'prop-types'
import Button from 'src/components/common/Button'

export default class CoHostNotice extends React.Component {
  render() {
    return <CheckoutFrame
      left={<>
        {<section className={styles['main-container']}>
          <div className={styles['action-description']}>
            <header>
              <h1>Unsent Invites</h1>
            </header>
            <p>Looks like your host {this.props.params.hostname} is out of invites. Let them know they need to upgrade their plan in order to send more invites.</p>
          </div>
          <footer>
            <Button onClick={() => {
              this.props.onClose()
            }}>Close</Button>
          </footer>
        </section>}
      </>}
      right={<img className={styles['send-invite-bg']} alt="Unsent Invites" src={SendInviteBg} />}
    />
  }
}

CoHostNotice.propTypes = {
  params: PropTypes.object,
  onClose: PropTypes.func
}
